export default __webpack_public_path__ + "static/media/divami.4c38aa56.webp";